<template>
  <div v-if="dataList.length" class="tow-level-product-category-wrapper">
    <template v-if="isSticky">
      <van-sticky :offset-top="offsetTop">
        <CakaTab :title="dataList" @scrollToAll="handleTabsClick"></CakaTab>
      </van-sticky>
    </template>
    <template v-else>
      <div>
        <CakaTab :title="dataList" @scrollToAll="handleTabsClick"></CakaTab>
      </div>
    </template>
  </div>
</template>

<script>
import CakaTab from "../../components/cake/CakaTab.vue";

export default {
  props: {
    isSticky: {
      type: Boolean,
      default: true,
    },
    offsetTop: {
      type: Number | String,
      default: 50,
    },
  },
  data() {
    return {
      navIndex: 0,
      dataList: [],
      cityCode: '',
      upgradeFlag: '',
      bathId: '',
    };
  },
  components: {
    CakaTab,
  },
  methods: {
    /** @returns {Promise<{ data: object|null, index: number }>} 供父级在 D 区决议后拉商品 */
    async init() {
      this.dataList = [];
      this.navIndex = 0;
      this.upgradeFlag = localStorage.getItem("upgradeFlag");
      this.bathId = localStorage.getItem("bathId");
      this.cityCode = localStorage.getItem("cityCode");
      return this.fetchDZoneThemes();
    },
    fetchDZoneThemes() {
      const form = {
        cardId: localStorage.getItem("cardId"),
        cityCode: this.cityCode,
        upgradeFlag: this.upgradeFlag,
        bathId: this.bathId,
        hotType: "D",
        showPositionCode: "0",
      };
      return this.$api
        .getQueryRotation(form)
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : [];
          this.dataList = list
            .filter((item) => item && item.showImgId && item.showImgId.id)
            .map((element) => ({
              description: element.description,
              name: element.name,
              id: element.showImgId.id,
              isShowD: true,
            }));
          return { data: this.dataList[0] || null, index: 0 };
        })
        .catch(() => {
          this.dataList = [];
          return { data: null, index: 0 };
        });
    },
    handleTabsClick(index) {
      this.$emit("change", { data: this.dataList[index], index });
    },
  },
};
</script>

<style lang="scss" scoped>
.tow-level-product-category-wrapper {
  margin-bottom: 0;
}
</style>
